import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { JobOffer } from 'job/job-offer';
import { JobOfferOutput } from 'job/model/job-offer.output';
import { JobOfferConverterPort } from 'job/port/job-offer-converter.port';

@Injectable()
export class JobOfferConverterAdapter
	extends ApplicationAdapter
	implements JobOfferConverterPort
{
	public jobOfferAsEntity(output: JobOfferOutput): JobOffer {
		if (!output) {
			return null;
		}

		return new JobOffer(
			output.id,
			output.title,
			output.owner?.id,
			output.keyPoints,
			output.companyName,
			output.documentUrl,
			output.contractType,
			output.modulesColumn
		);
	}

	public jobOffersAsEntities(outputs: JobOfferOutput[]): JobOffer[] {
		return reject(outputs, isNil).map((output) => this.jobOfferAsEntity(output));
	}
}
